import React, { useEffect, useState } from 'react';

// components
import { Row, Col, Nav, NavItem, NavLink, Button } from "reactstrap";

// helpers
import { formateDateandTime } from "../../../helpers/formats.js";

// Views
import ModalEnderecoMapa from './ModalEnderecoMapa';
import EditarRespostaBoletim from './components/EditarRespostaBoletim';
import FotoCard from './components/FotoCard';
import { getSessionCookie } from '../../../helpers/cookies.js';

export default function Inspecoes({ boletimVistoria, permitirEditarBoletim, setBoletimVistoria }) {
    const [stepFormulario, set_stepFormulario] = useState(0);

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    // state para guarda a questao que vai ser editado
    const [questaoEditar, setQuestaoEditar] = useState(null);

    const session = getSessionCookie();

    useEffect(() => {
        if (boletimVistoria && boletimVistoria.boletimVistoriaInspecoes.length > 0) {
            set_stepFormulario(boletimVistoria.boletimVistoriaInspecoes[0].boletimVistoriaInspecao_Id);
        }
    }, [boletimVistoria]);

    const [isOpenModalInspecao, set_isOpenModalInspecao] = useState(false);
    const [localizacaoInspecao, set_localizacaoInspecao] = useState(null)
    const handleOpenModalInspecao = (inspecao) => {
        set_isOpenModalInspecao(true);
        set_localizacaoInspecao([inspecao.geoLocalizacao.split(';')[0], inspecao.geoLocalizacao.split(';')[1]]);
    }

    return (
        <>
            {/* Título antigo "Inspeções" removido para dar lugar à nova seção moderna abaixo */}
            <Nav justified tabs pills className="mr-auto">
                {boletimVistoria.boletimVistoriaInspecoes.map((m, key) => (
                    <NavItem key={key}>
                        <NavLink
                            active={m.boletimVistoriaInspecao_Id === stepFormulario}
                            onClick={() => set_stepFormulario(m.boletimVistoriaInspecao_Id)}>
                            {m.local}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
            {boletimVistoria.boletimVistoriaInspecoes.filter(f => f.boletimVistoriaInspecao_Id === stepFormulario).map((m, key) => (
                <React.Fragment key={key}>
                    <Row className="align-items-end">
                        <Col lg="8" md="8" sm="12" className="pb-2">
                            <strong>Endereço: </strong><span>{m.logradouro + ", " + m.bairro}</span>
                        </Col>
                        {m.geoLocalizacao &&
                            <Col lg="4" md="4" sm="12" className="pb-2 text-right">
                                <Button color="link" onClick={() => handleOpenModalInspecao(m)}><i className="fas fa-map"></i> Visualizar no Mapa</Button>
                            </Col>
                        }
                    </Row>
                    <Row className="align-items-end">
                        <Col lg="3" md="3" sm="12">
                            <strong>Início: </strong><span>{formateDateandTime(m.dataHoraInicio)}</span>
                        </Col>
                        <Col lg="3" md="3" sm="12">
                            <strong>Fim: </strong><span>{formateDateandTime(m.dataHoraFim)}</span>
                        </Col>
                    </Row>

                    {/* Novo Bloco de Evidências Gerais da Inspeção */}
                    {(() => {
                        const fotosGerais = m.boletimVistoriaInspecaoFotos.filter(f => !f.formularioVistoriaQuestao_Id);
                        if (fotosGerais.length > 0) {
                            return (
                                <div className="mt-4 mb-2">
                                    <h6 className="mb-3 font-weight-bold" style={{ color: '#444', borderLeft: '5px solid #17a2b8', paddingLeft: '10px' }}>
                                        Evidências da Inspeção
                                    </h6>
                                    <Row className="justify-content-center">
                                        {fotosGerais.map((foto, keyfoto) => (
                                            <Col lg="4" md="6" sm="12" key={keyfoto} className="px-2">
                                                <FotoCard foto={foto} altText={`Evidência Geral da Inspeção ${m.local}`} />
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            );
                        }
                        return null;
                    })()}

                    {/* Caso exista alguma questão para ser editada */}
                    {modal &&
                        <EditarRespostaBoletim
                            modalVisibilidade={modal}
                            setModalVisibilidade={toggle}
                            questaoEditar={questaoEditar}
                            setQuestaoEditar={setQuestaoEditar}
                            stepFormulario={stepFormulario}
                            boletimVistoria={boletimVistoria}
                            setBoletimVistoria={setBoletimVistoria}
                        />
                    }

                    <div className="mt-4 border rounded bg-white overflow-hidden shadow-sm">
                        {/* Custom Table Header */}
                        <Row className="bg-light border-bottom py-2 px-3 font-weight-bold d-none d-md-flex" style={{ fontSize: '1rem', color: '#444' }}>
                            <Col md="5">Pergunta</Col>
                            <Col md="3">Resposta</Col>
                            {boletimVistoria.situacaoAnalise !== "Aguardando Análise" &&
                                (session.perfil === "Gestor" || session.perfil === "Agente Fiscalizador" || session.perfil === "Administrador") &&
                                <Col md="3">Valor Original</Col>
                            }
                            <Col md="1"></Col>
                        </Row>

                        {/* Custom Table Body */}
                        {m.boletimVistoriaQuestoes.map((n, key2) => {
                            const fotosQuestao = m.boletimVistoriaInspecaoFotos.filter(f => f.formularioVistoriaQuestao_Id === n.formularioVistoriaQuestao_Id);
                            const hasInconformidade = n.penalidade;

                            return (
                                <div key={key2} className={`border-bottom py-3 px-3`} style={{ borderLeft: hasInconformidade ? '4px solid #dc3545' : 'none', backgroundColor: key2 % 2 === 0 ? '#fff' : '#fafafa' }}>
                                    <Row className="align-items-start">
                                        <Col md="5" sm="12" className="mb-2 mb-md-0 font-weight-bold" style={{ color: '#333' }}>
                                            <span className="d-md-none mr-1 text-muted small">Pergunta:</span>
                                            {n.formularioVistoriaQuestao_Identificacao}
                                        </Col>
                                        <Col md="3" sm="12" className="mb-2 mb-md-0">
                                            <span className="d-md-none font-weight-bold mr-1 text-muted small">Resposta:</span>
                                            <span className={hasInconformidade ? 'text-danger font-weight-bold' : ''}>{n.valor}</span>
                                            {permitirEditarBoletim &&
                                                <button
                                                    className='ml-2 border-0 rounded-circle bg-transparent text-center p-0'
                                                    style={{ color: '#007bff' }}
                                                    onClick={() => {
                                                        setQuestaoEditar(n);
                                                        toggle();
                                                    }}
                                                >
                                                    <i className='fas fa-pencil-alt' ></i>
                                                </button>
                                            }
                                        </Col>
                                        {boletimVistoria.situacaoAnalise !== "Aguardando Análise" &&
                                            (session.perfil === "Gestor" || session.perfil === "Agente Fiscalizador" || session.perfil === "Administrador") &&
                                            <Col md="3" sm="12" className="mb-2 mb-md-0 text-muted" style={{ fontSize: '0.85rem' }}>
                                                <span className="d-md-none font-weight-bold mr-1 text-muted small">Valor Original:</span>
                                                {n.valorOriginal || '-'}
                                            </Col>
                                        }
                                        <Col md="1" sm="2" className="text-right">
                                            {n.penalidade && <i className="fas fa-exclamation-circle text-danger" title="Inconformidade"></i>}
                                        </Col>
                                    </Row>

                                    {/* Question Photos - Dedicated Second Row */}
                                    {fotosQuestao.length > 0 &&
                                        <Row className="mt-3 justify-content-center">
                                            {fotosQuestao.map((foto, keyfoto) => (
                                                <Col lg="4" md="6" sm="12" key={keyfoto} className="px-2">
                                                    <FotoCard foto={foto} altText={`Foto da questão ${n.formularioVistoriaQuestao_Identificacao}`} />
                                                </Col>
                                            ))}
                                        </Row>
                                    }
                                </div>
                            );
                        })}
                    </div>

                    <div className="mt-4">
                        <label><i className="fas fa-exclamation-circle text-danger"></i> Respondido com inconformidade</label>
                    </div>

                    <ModalEnderecoMapa
                        isOpen={isOpenModalInspecao}
                        handleReturn={() => set_isOpenModalInspecao(false)}
                        position={localizacaoInspecao}
                    />
                </React.Fragment>
            ))}
        </>
    );
}
